/* globals API_URL, PUBLIC_URL, STATIC_URL, GOOGLE_MAP_API_KEY, MYHOME_URL, MINISITE_URL, SSO_URL, BSMART_URL, MIRAGE_SCENARIO, MESSAGES_DEBUG, MESSAGES_ENABLE, FORMAZIONE_URL */

export default {
  static: filename => `${STATIC_URL}${filename}`,
  googleKey: GOOGLE_MAP_API_KEY,
  // This must be bumped whenever the output of /api/v1/config changes
  cacheVersion: 4,
  sentryDSN: "https://bec5b8d350044b2a937a452b0cb4cdf5@sentry.nephila.it/145",
  activation_search_url: `${SSO_URL}/#/user/landing/search`,
  activation_url: `${SSO_URL}/#/user/landing/start`,
  profile_teacher_url: `${MYHOME_URL}/#/my-profile/data`,
  profile_student_url: `${MYHOME_URL}/#/my-profile/data`,
  profile_parent_url: `${MYHOME_URL}/#/my-profile/data`,
  profile_principal_url: `${MYHOME_URL}/#/my-profile/data`,
  profile_generic_url: `${MYHOME_URL}/#/my-profile/data`,
  register_url: `${SSO_URL}/#/user/signup/start`,
  login_url: `${SSO_URL}/#/user/login`,
  logout_url: `${SSO_URL}/#/user/logout`,
  myhome_url: `${MYHOME_URL}`,
  evaluation_book_url: `${SSO_URL}/#/user/landing/activate/%(book)s/evaluation1`,
  activation_book_url: `${SSO_URL}/#/user/landing/activate/%(book)s/composition`,
  mybooks_teacher_url: `${SSO_URL}/#/books`,
  mybooks_student_url: `${SSO_URL}/#/books`,
  mybooks_family_url: `${SSO_URL}/#/books`,
  myfamily_url: `${SSO_URL}/#/my-profile/family`,
  family_students_url: `${SSO_URL}/#/user/login?mode=switch`,
  schools_url: `${MYHOME_URL}/#/my-profile/schools`,
  agents_url: `${MYHOME_URL}/#/my-profile/support`,
  support_url: "https://deascuola.it/assistenza/",
  formazione_url: "https://formazione.deascuola.it/offerta-formativa/",
  // eslint-disable-next-line no-template-curly-in-string
  parent_login: `${SSO_URL}/#/user/login?mode=parent&child_id=\${child}&force_return=true&url=\${url}`,
  switch_login: `${SSO_URL}/#/user/login?mode=switch`,
  bsmart_login: `${BSMART_URL}/users/sign_in`,
  bsmart_profile: `${BSMART_URL}/profile/accounts`,
  bsmart_connect: `https://assistenza.deascuola.it/attivazione-ebook-e-corredo-digitale/scollegare-un-account-bsmart`,
  bsmart_dea_login: `${BSMART_URL}/users/auth/deascuola`,
  blackcat_cideb_login: "https://www.blackcat-cideb.com/it/profile/",
  bookmarks_enabled: true,
  bookmarks_resource_enabled: true,
  share_enabled: false,
  share_resource_enabled: true,
  share_resource_teacher_enabled: true,
  share_resource_teacher_warning_message:
    "Questa risorsa è dedicata ai Docenti. Puoi condividerla con chi vuoi, ma fa' attenzione che sia in buone mani",
  cart_enabled: false,
  apiRoot: API_URL,
  publicURL: PUBLIC_URL,
  homeURL: `${API_URL}/api/v1/accounts/services/`,
  newBooksURL: `${API_URL}/api/v1/read/catalog/work/new/demo/`,
  activationsURL: `${API_URL}/api/v1/activations/myhome/`,
  userURL: `${API_URL}/auth/user/`,
  userSwitchURL: `${API_URL}/api/v1/accounts/user/switch/`,
  configURL: `${API_URL}/api/v1/config/`,
  autosuggestLinksURL: `${API_URL}/api/v1/autosuggestlinks/`,
  ordersListURL: `${API_URL}/api/v1/orders/list/`,
  agencyUpdate: `${API_URL}/api/v1/accounts/user/agency/update/`,
  minisiteURL: `${MINISITE_URL}`,
  avatarsURL: `https://users.deascuola.it/assets/img/illustration`,
  enableClassroom: true,
  enableWeSchool: true,
  weSchoolShareUrl: "https://app.weschool.com/#share?url=",
  bSmartShareUrl: "https://www.bsmart.it",
  agenciesListUrl: `${API_URL}/api/v1/sales/user/`,
  enableTeams: true,
  activitiesList: [
    "Referente per la formazione",
    "Animatore digitale e/o membro team innovazione",
    "Funzione strumentale per la formazione/valutazione",
    "Funzione strumentale nuove tecnologie",
    "Funzione strumentale inclusione",
    "Funzione strumentale orientamento/ASL",
    "Referente prevenzione cyberbullismo",
  ],
  grades: ["Primaria", "Secondaria di I grado", "Secondaria di II grado"],
  schoolsTypologies: [
    "Liceo Artistico",
    "Liceo Classico",
    "Liceo Linguistico",
    "Liceo Musicale e Coreutico",
    "Liceo Scientifico",
    "Liceo delle Scienze Umane",
    "Istituto Tecnico Economico",
    "Istituto Tecnico Tecnologico",
    "Istituto Professionale Servizi",
    "Istituto Professionale Industria Artigianato",
  ],
  api: {
    base: FORMAZIONE_URL || "https://api.formazione.deascuola.it",
    fetchCart: "/api/v1/orders/cart/",
    fetchOrder: "/api/v1/orders/current/",
    orderBase: "/api/v1/orders/",
    orderBundleLegs: "/set-bundle-legs/",
    registrationBase: "/api/v1/registrations/",
    fetchUser: `${API_URL}/auth/user/`,
    setFiscalCode: "/api/v1/user/fc/",
    states: {
      new: "new",
      data_confirmation: "data-confirmation",
      completed: "completed",
      payment_start: "payment-start",
      waiting_list: "waiting-list",
      pre_registration: "pre-registration",
    },
    tokenName: "deatoken",
    csrfToken: "csrftoken",
  },
  schoolApi: "https://crm.a.deascuola.it/v1",
  getCityParams: {
    groupBy: "city",
    limit: "100",
    orderBy: "city",
  },
  getSchoolsParams: {
    limit: "10",
    orderBy: "name",
  },
  userApi: "https://identity.a.deascuola.it/v1",
  userApiv2: "https://identity.a.deascuola.it/v2",
  states: {
    New: "new",
    LegSelection: "select_legs",
    Laboratories: "data_confirmation",
    LabsList: ["completed", "payment_start"],
    Tickets: "active",
    pending: ["waiting_list", "pre_registration"],
    waiting_list: "waiting_list",
    pre_registration: "pre_registration",
    on_hold: "payment_on_hold",
    Confirmed: ["active", "waiting_list", "pre_registration", "payment_on_hold"],
    FiscalCodeConfirmation: ["new", "data_confirmation"],
    StartOrEndedRegistration: ["payment_start", "data_confirmation", "completed", "select_legs"],
    Cancelled: "cancelled",
  },
  gtm: {
    affiliation: "DeA Scuola Formazione",
    brand: "DeA Scuola Formazione",
    currencyCode: "EUR",
  },
  eventsURL: "https://api.formazione.deascuola.it/api/v1/registrations/",
  myevents_url: "https://areapersonale.deascuola.it/#/event/",
  workURL: "https://deascuola.it/work/",
  autosuggest: {
    autosuggestUrl: [{ channel: "resources", url: `${API_URL}/api/v1/autosuggestlinks/` }],
    initialStatus: "open",
    isStaticSearch: true,
    groupNames: {
      links: "Link rapidi",
      queries: "Ricerche suggerite",
    },
    searchUrl: `${API_URL}/ricerca/`,
  },
  evaluationSearch: {
    autosuggestUrl: [{ channel: "resources", url: "https://search.a.deascuola.it/v1/doc/live" }],
    initialStatus: "open",
    isStaticSearch: false,
    linkBase: `${SSO_URL}/#/user/landing/activate/%(book)s/evaluation1`,
    linkTarget: "_blank",
  },
  activationSearch: {
    autosuggestUrl: [{ channel: "resources", url: "https://search.a.deascuola.it/v1/doc/live" }],
    initialStatus: "open",
    isStaticSearch: false,
    linkBase: `${SSO_URL}/#/user/landing/activate/%(book)s/composition`,
    linkTarget: "_blank",
  },
  buttonConfig: {
    actionButton: true,
    bgColor: "",
    buttonModifier: "",
    iconClass: "",
    label: "Area Personale",
    registrationBase: "https://areapersonale.deascuola.it",
    userLabel: "",
    useRouter: true,
    personalArea: true,
  },
  linksLeft: [
    {
      className: "dea-header--top__links dea-links--small dea-links--no-border",
      href: "https://deascuola.it",
      icon: "",
      iconClass: "",
      label: "DeA Scuola",
    },
    {
      className: "dea-header--top__links dea-links--small dea-links--no-border",
      href: "https://formazione.deascuola.it",
      icon: "",
      iconClass: "",
      label: "DeA Formazione",
    },
    {
      className: "dea-header--top__links dea-links--small dea-links--no-border",
      href: "https://blog.deascuola.it",
      icon: "",
      iconClass: "",
      label: "DeA Live",
    },
  ],
  linksRight: [
    {
      className: "dea-header--top__links dea-links--small dea-links--no-border",
      href: "https://deascuola.it/rete-commerciale/",
      icon: "",
      iconClass: "",
      label: "Rete Commerciale",
    },
    {
      className: "dea-header--top__links dea-links--small dea-links--no-border",
      href: "https://deascuola.it/assistenza/",
      icon: "",
      iconClass: "",
      label: "Assistenza",
    },
  ],
  logos: [
    {
      ariaLabel: "Logo DeA Scuola",
      pictureClass: {
        transparent: "logo--dea__transparent",
        desktop: "logo--dea__desktop",
        mobile: "logo--dea__mobile",
      },
      screenSize: {
        transparent: `${STATIC_URL}img/logo/dea/deascuola_logo.svg`,
        desktop: `${STATIC_URL}img/logo/dea/deascuola_logo.svg`,
        mobile: `${STATIC_URL}img/logo/dea/deascuola_logo.svg`,
      },
      url: PUBLIC_URL,
    },
  ],
  mainHeaderLogo: `${STATIC_URL}img/logo/dea/deascuola_logo.svg`,
  profileMenu: [],
  sections: {
    group: {
      label: "",
      class: "",
      url: "/",
    },
  },
  // Used mocked data instead of API calls - set to the mock file name (parent also loads child1.json)
  useMock: false,
  tooltipLinks: {
    "home": "home",
    "books": "books",
    "events": "events",
    "bookmarks-resources": "bookmarks/resources",
  },
  bookmarkOrigin: {
    label: "Area Personale",
    code: "deascuola",
  },
  videoLaunch: {
    teacher: "https://www.youtube.com/embed/GMZUV1vxZqk",
    student: "https://www.youtube.com/embed/cDphh4EN3wk",
    parent: "https://www.youtube.com/embed/UH0x3dLA5Lg",
  },
  userAgeWarning: {
    default: 18,
    student: 14,
  },
  schoolRoles: ["Insegnante di ruolo", "Insegnante NON di ruolo", "Insegnante di sostegno"],
  loadingErrorTimeout: 30000,
  sourceSite: "deascuola",
  messages: {
    debug: MESSAGES_DEBUG,
    enable: MESSAGES_ENABLE,
    priorityOrder: [
      {
        icon: "info",
        intro: "INFO:",
        single: {
          label: "La tua agenzia di riferimento ti propone un nuovo libro da valutare: %NAME%.",
          cta: {
            ALL: "Vai al libro",
          },
          url: {
            // FIXME: use book url
            ALL: "https://%BOOK%.su.deascuola.it/#/",
          },
        },
        multi: {
          label: "La tua agenzia di riferimento ti propone %NUM% nuovi libri da valutare.",
          cta: {
            ALL: "Vai a I miei libri",
          },
          url: {
            ALL: "/books",
          },
        },
        topic: "EVALUATION_NEW",
      },
      {
        icon: "alert",
        intro: "Attenzione:",
        single: {
          label: "Il tuo libro %NAME% sarà ancora disponibile solo per 30 giorni.",
          cta: {
            ROLE_TEACHER: "Contatta la tua agenzia",
            ROLE_STUDENT: "Vai al libro",
            ROLE_PARENT: "Vai al libro",
          },
          url: {
            ROLE_TEACHER: "/my-profile/support",
            ROLE_STUDENT: "https://%BOOK%.su.deascuola.it/#/",
            ROLE_PARENT: "https://%BOOK%.su.deascuola.it/#/",
          },
        },
        multi: {
          label: "",
          cta: {},
          url: {},
        },
        topic: "ACTIVATION_EXPIRING",
      },
      {
        icon: "alert",
        intro: "Attenzione:",
        single: {
          label: "Hai ancora solo 7 giorni per valutare il libro %NAME%.",
          cta: {
            ALL: "Vai al libro",
          },
          url: {
            ALL: "https://%BOOK%.su.deascuola.it/#/",
          },
        },
        multi: {
          label: "",
          cta: {},
          url: {},
        },
        topic: "EVALUATION_EXPIRING",
      },
      {
        icon: "info",
        intro: "INFO:",
        source: {
          default: "La tua agenzia di riferimento",
          ROLE_ADMIN: "Il servizio clienti Deascuola",
          ROLE_SUPERADMIN: "Il servizio clienti Deascuola",
        },
        single: {
          label: "%SOURCE% ha attivato per te un nuovo libro: %NAME%.",
          cta: {
            ALL: "Vai al libro",
          },
          url: {
            ALL: "https://%BOOK%.su.deascuola.it/#/",
          },
        },
        multi: {
          label: "%SOURCE% ha attivato per te %NUM% nuovi libri.",
          cta: {
            ALL: "Vai ai miei libri",
          },
          url: {
            ALL: "/books",
          },
        },
        topic: "ACTIVATION_NEW",
      },
      {
        icon: "alert",
        intro: "Attenzione:",
        single: {
          label: "Il periodo a tua disposizione per valutare %NAME% è terminato. Hai bisogno più tempo?",
          cta: {
            ALL: "Contatta la tua agenzia",
          },
          url: {
            ALL: "/my-profile/support",
          },
        },
        multi: {
          label: "",
          cta: {},
          url: {},
        },
        topic: "EVALUATION_EXPIRED",
      },
    ],
  },
  MIRAGE_SCENARIO,
};
